import { WidgetDetailedInfo, WidgetPropertiesProvider } from "@wms/design-container";

export const containersConfig: { [key: string]: WidgetDetailedInfo } = {
  'wm-accordion': {
    "widgetType": "wm-accordion",
    "template":
      "<wm-accordion type='static' statehandler='URL'>" +
      "<wm-accordionpane></wm-accordionpane>" +
      "<wm-accordionpane></wm-accordionpane>" +
      "<wm-accordionpane></wm-accordionpane>" +
      "</wm-accordion>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "accordion"
  },
  'wm-accordionpane': {
    "widgetType": "wm-accordionpane",
    "template":
      "<wm-accordionpane></wm-accordionpane>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": false,
    "isPageContainer": true,
    "tokenFileName": "accordion-pane",
 styleWorkspaceTemplates: {
      platforms: {
        native_mobile: {
          customTemplate: [`<wm-accordion type="static" statehandler="URL" name="accordion1" >
                <wm-accordionpane name="accordionpane1">
                    <wm-label caption="Accordion pane content" padding="unset" name="label1" class="p" variant="default:p"></wm-label>
                </wm-accordionpane>
                </wm-accordion>`]
        }
      }
    }
  },
  'wm-repeat-template': {
    "widgetType": "wm-repeat-template",
    "template":
      "<wm-repeat-template></wm-repeat-template>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": false,
    "isPageContainer": true
  },
  'wm-container': {
    "widgetType": "wm-container",
    "template": "<wm-container></wm-container>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": true,
    "isPageContainer": true,
    "isLayoutBundled": true,
    "tokenFileName": "container",
    styleWorkspaceTemplates : {
       customTemplate: [`<wm-container height="200px" width="100%"></wm-container>`],  
    }
  },
  'wm-tile': {
    "widgetType": "wm-tile",
    "template": "<wm-tile>" +
      "<wm-layoutgrid height='100%'>" +
      "<wm-gridrow height='100%'>" +
      "<wm-gridcolumn columnwidth='3' horizontalalign='center'>" +
      "<wm-icon name='tileIcon' iconclass='wi wi-bar-chart fa-3x'></wm-icon>" +
      "</wm-gridcolumn>" +
      "<wm-gridcolumn columnwidth='9' horizontalalign='center'>" +
      "<wm-label name='tileTitle' caption='title' class='p' fontunit='em'></wm-label>" +
      "<wm-label name='tileStatLabel' caption='00' fontunit='em' class='h1'></wm-label>" +
      "</wm-gridcolumn>" +
      "</wm-gridrow>" +
      "</wm-layoutgrid>" +
      "</wm-tile>",
    "platforms": {
      "native_mobile": {
        "template": '<wm-tile class="bg-primary">' +
        '<wm-linearlayout direction="row" height="100%" verticalalign="center">' +
            '<wm-linearlayoutitem horizontalalign="center" height="auto">' +
          '<wm-icon iconclass="wi wi-bar-chart fa-2x" class="tile-template-text"></wm-icon>'+
          '</wm-linearlayoutitem>' +
          '<wm-linearlayoutitem flexgrow="1" height="auto">' +
          '<wm-linearlayout direction="column" spacing="10px">' +
          '<wm-linearlayoutitem horizontalalign="center">' +
          '<wm-label caption="title" fontunit="px" textalign="center" class="tile-template-text"></wm-label>' +
          '</wm-linearlayoutitem>' +
          '<wm-linearlayoutitem horizontalalign="center">' +
          '<wm-label caption="00" fontunit="px" textalign="center" class="tile-template-text"></wm-label>' +
          '</wm-linearlayoutitem>' +
          '</wm-linearlayout>' +
          '</wm-linearlayoutitem>' +
          '</wm-linearlayout>' +
          '</wm-tile>'
      }
    },
    styleWorkspaceTemplates: {
      platforms: {
        native_mobile: {
          customTemplate: [`<wm-tile name="tile1"  height="100px">
            <wm-linearlayout direction="row" height="100%" verticalalign="center" name="linearlayout1">
                <wm-linearlayoutitem horizontalalign="center" height="auto" name="linearlayoutitem1">
                    <wm-icon iconclass="wi wi-bar-chart fa-2x" class="tile-template-text fa-xs" name="icon1"
                        variant="default:xs"></wm-icon>
                </wm-linearlayoutitem>
                <wm-linearlayoutitem flexgrow="1" height="auto" name="linearlayoutitem2">
                    <wm-linearlayout direction="column" spacing="10px" name="linearlayout2">
                        <wm-linearlayoutitem horizontalalign="center" name="linearlayoutitem3">
                            <wm-label caption="title" fontunit="px" textalign="center" class="tile-template-text"
                                name="label1" variant="default:p"></wm-label>
                        </wm-linearlayoutitem>
                        <wm-linearlayoutitem horizontalalign="center" name="linearlayoutitem4">
                           
                        </wm-linearlayoutitem>
                    </wm-linearlayout>
                </wm-linearlayoutitem>
            </wm-linearlayout>
        </wm-tile>`]
      }
    } 
  },
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": true,
    "isPageContainer": false,
    "tokenFileName": "tile"
  },
  'wm-media-list': {
    "widgetType": "wm-media-list",
    "template": "<wm-media-list><wm-media-template></wm-media-template></wm-media-list>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true
  },
  'wm-media-template': {
    "widgetType": "wm-media-template",
    "template": "<wm-media-template></wm-media-template>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": false,
    "canBeCopied": false,
    "parent": "wm-media-list"
  },
  'wm-breadcrumb': {
    "widgetType": "wm-breadcrumb",
    "template": "<wm-breadcrumb dataset='Home, Page' class='path-based'></wm-breadcrumb>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "isLayoutBundled": true,
    "isPageContainer": false,
  },
  'wm-layoutgrid': {
    "widgetType": "wm-layoutgrid",
    "template":
      "<wm-layoutgrid>" +
      "<wm-gridrow>" +
      "<wm-gridcolumn columnwidth='6'></wm-gridcolumn>" +
      "<wm-gridcolumn columnwidth='6'></wm-gridcolumn>" +
      "</wm-gridrow>" +
      "<wm-gridrow>" +
      "<wm-gridcolumn columnwidth='6'></wm-gridcolumn>" +
      "<wm-gridcolumn columnwidth='6'></wm-gridcolumn>" +
      "</wm-gridrow>" +
      "</wm-layoutgrid>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "grid-layout"
  },
  'wm-gridrow': {
    "widgetType": "wm-gridrow",
    "template": "<wm-gridrow></wm-gridrow>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": false,
    "scaffold": true
  },
  'wm-gridcolumn': {
    "widgetType": "wm-gridcolumn",
    "template": "<wm-gridcolumn></wm-gridcolumn>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": false,
    "scaffold": true
  },
  'wm-linearlayout': {
    "widgetType": "wm-linearlayout",
    "template":
      "<wm-linearlayout direction=\"column\" spacing=\"4\" padding=\"4px\">" +
      "<wm-linearlayoutitem flexgrow=\"1\"></wm-linearlayoutitem>" +
      "</wm-linearlayout>",
      "rightActionPanel": async function (layoutInstance: any, layoutElement: any) {
        return await layoutInstance.buildActionPanel(layoutElement, 'right');
      },
      "bottomActionPanel":  async  function (layoutInstance: any, layoutElement: any) {
        return await layoutInstance.buildActionPanel(layoutElement, 'bottom');
      },
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true
  },
  'wm-linear-flex-layout': {
    "widgetType": "wm-linear-flex-layout",
    "template":
      "<wm-linearlayout direction=\"row\" spacing=\"4\" padding=\"4px\">" +
      "<wm-linearlayoutitem></wm-linearlayoutitem>" +
      "<wm-linearlayoutitem flexgrow=\"1\"></wm-linearlayoutitem>" +
      "<wm-linearlayoutitem></wm-linearlayoutitem>" +
      "</wm-linearlayout>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true
  },
  'wm-linear-h-layout': {
    "widgetType": "wm-linear-h-layout",
    "template":
      "<wm-linearlayout direction=\"row\" spacing=\"4\">" +
      "<wm-linearlayoutitem flexgrow=\"1\"></wm-linearlayoutitem>" +
      "<wm-linearlayoutitem flexgrow=\"1\"></wm-linearlayoutitem>" +
      "</wm-linearlayout>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true
  },
  'wm-linear-v-layout': {
    "widgetType": "wm-linear-v-layout",
    "template":
      "<wm-linearlayout direction=\"column\" spacing=\"4\">" +
      "<wm-linearlayoutitem flexgrow=\"1\"></wm-linearlayoutitem>" +
      "<wm-linearlayoutitem  flexgrow=\"1\"></wm-linearlayoutitem>" +
      "</wm-linearlayout>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true
  },
  'wm-linearlayoutitem': {
    "widgetType": "wm-linearlayoutitem",
    "template": "<wm-linearlayoutitem></wm-linearlayoutitem>",
    "rightActionPanel": async function (layoutItemInstance: any, layoutItemElement: any) {
      return await layoutItemInstance.buildActionPanel(layoutItemElement, 'right');
    },
    "bottomActionPanel": async function (layoutItemInstance: any, layoutItemElement: any) {
      return await layoutItemInstance.buildActionPanel(layoutItemElement, 'bottom');
    },
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": true
  },
  'wm-list': {
    "widgetType": "wm-list",
    "template": "<wm-list></wm-list>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": true,
    "isTemplateBundled": true,
    "tokenFileName": "list",
    "config": {
      'requireVariable': true,
      'title': 'List',
      'bindTypes': ['wm-livefilter', 'wm-list', 'wm-table', 'wm-chart', 'wm-prefab'],
      'screens': [
        {
          "id": 'livelist-config',
          "label": "Template",
          "screen": "templateConfig",
          "liveWidgetId": "wm-list",
          "description": "MESSAGE_WIDGET_SELECT_TEMPLATE",
          "templates": [
            {
              "id": "text-list",
              "title": "Text",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Text List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                '<wm-label name="Text" caption="{}" data-is-target class="h4" padding="12px"></wm-label>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "text-with-avatar-list",
              "title": "Text with Avatar",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Text with Avatar List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                '<wm-container direction="row" alignment="middle-left" gap="12" width="fill" name="container4" class="app-default-container" variant="default" padding="12px">' +      
                '<wm-picture width="58px" height="58px" name="Picture" picturesource="{}" data-is-target shape="circle" resizemode="cover" class="media-object"></wm-picture>' +
                '<wm-container direction="column" flexgrow="1" gap="12" width="fill">' +
                '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold"></wm-label>' +
                '<wm-label name="SubTitle" caption="{}" data-is-target class="h5"></wm-label>' +
                '</wm-container>' +
                '<wm-icon iconclass="wi wi-more-vert" iconsize="22px"></wm-icon>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "text-with-description-list",
              "title": "Text with Description",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
               "template":
                      ' <wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Text with Description List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                      '<wm-listtemplate layout="inline">' +
                      ' <wm-container direction="row" alignment="top-left" gap="12" name="container4" class="app-default-container" variant="default" padding="12px">' +
                      '<wm-picture width="58px" height="58px" name="Picture" picturesource="{}" data-is-target shape="circle" resizemode="cover" class="media-object"></wm-picture>' +
                      '<wm-container direction="column" spacing="4">' +
                      '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold"></wm-label>' +
                      '<wm-label name="SubTitle" caption="{}" margin="unset 4px" data-is-target></wm-label>' +
                      '<wm-label name="Description" caption="{}" data-is-target class="h5"></wm-label>' +
                      "</wm-container" +
                      "</wm-container>" +
                      "</wm-listtemplate>" +
                      "</wm-list>",
            },
            {
              "id": "action-list",
              "title": "Action List",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Action List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                '<wm-container class="media-left">' +
                '<wm-picture width="32pt" height="32pt" name="Picture" shape="circle" data-is-target picturesource="{}" class="media-object"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body" padding="unset unset unset 1.25em">' +
                '<wm-label name="Name" data-is-target class="p media-heading" caption="{}" fontsize="1.143" fontunit="em"></wm-label>' +
                '<wm-label name="JobTitle" data-is-target caption="{}" class="p text-muted"></wm-label>' +
                '</wm-container>' +
                '<wm-container class="media-right media-top">' +
                '<wm-button type="button" class="btn-transparent" iconclass="wi wi-share fa-2x"></wm-button>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "contact-list",
              "title": "Contact List",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Contact List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" datafield="All Fields" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                '<wm-container class="media-left">' +
                '<wm-picture width="32pt" height="32pt" name="Picture" shape="circle" data-is-target picturesource="{}" class="media-object"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body">' +
                '<wm-label class="p media-heading" name="Name" data-is-target caption="{}" fontunit="em" padding="unset unset unset 1.25em"></wm-label>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "email-list",
              "title": "Email List",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Email List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                '<wm-container name="pictureContainer" class="media-left">' +
                '<wm-picture width="32pt" height="32pt" name="Picture" shape="circle" data-is-target picturesource="{}" class="media-object"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body" padding="unset unset unset 1.25em">' +
                '<wm-label name="Name" data-is-target class="media-heading pull-left" caption="{}" fontunit="em"></wm-label>' +
                '<wm-label name="Time" data-is-target caption="{}" class="pull-right" margin="0px unset unset unset"></wm-label>' +
                '<wm-label caption="{}" data-is-target class="h5" margin="0px unset unset unset" name="JobTitle"></wm-label>' +
                '<wm-label name="Content" data-is-target caption="{}" class="p text-muted"></wm-label>' +
                '</wm-container>' +
                '<wm-container class="media-right"></wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'

            },
            {
              "id": "media-list",
              "title": "Media List",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Media List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-container class="media-left media-top">' +
                '<wm-picture name="Picture" data-is-target class="media-object" width="32pt" height="32pt" picturesource="{}"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body" padding="unset 1.5em unset 1.25em">' +
                '<wm-label class="pull-left" caption="{}" data-is-target name="Name" margin="0em unset 0.5em unset" fontsize="1.143" fontunit="em"></wm-label>' +
                '<wm-label name="Time" data-is-target class="pull-right text-muted" caption="{}"></wm-label>' +
                '<wm-label caption="{}" data-is-target name="Description" class="p text-muted"></wm-label>' +
                '</wm-container>' +
                '<wm-container class="media-right" horizontalalign="right" padding="unset 1em unset unset">' +
                '<wm-menu autoclose="outsideClick" caption="" type="anchor" iconclass="wi wi-more-vert" menuposition="down,left"></wm-menu>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'

            },
            {
              "id": "list-form-device",
              "title": "List with Form",
              "platform": ["MOBILE"],
              "template":
                '<wm-list listclass="list-group" itemclass="list-group-item media" template="true" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-container class="media-left">' +
                '<wm-picture data-is-target class="media-object picture" shape="circle" width="40pt" name="Picture" picturesource="{}" hint="{}"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body">' +
                '<wm-label data-is-target caption="{}" name="Name" class="p media-heading" ></wm-label>' +
                '<wm-label data-is-target caption="{}" class="p text-muted" name="Title"></wm-label>' +
                '</wm-container>' +
                '<wm-container class="media-right media-top" width="20%" name="container9" horizontalalign="right">' +
                '<wm-buttongroup name="buttongroup1">' +
                '<wm-button type="button" class="btn-transparent edit-list-item" caption="" name="button1" iconclass="wi wi-pencil fa-2x" margin="unset 0.2em unset unset"></wm-button>' +
                '<wm-button type="button" class="btn-transparent delete-list-item" caption="" name="button2" iconclass="wi wi-trash fa-2x"></wm-button>' +
                '</wm-buttongroup>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>' +
                '<wm-liveform  errormessage="" title="Details" formlayout="dialog" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>'
            }
          ]
        },
        {
          "id": 'livelist-fields',
          "label": "Bind Fields",
          "screen": "liveListFieldConfig",
          "description": "MESSAGE_WIDGET_MAP_FIELDS",
          "liveWidgetId": "wm-list"
        }
      ]
    }, 
    styleWorkspaceTemplates : {
      customTemplate : [`<wm-list listclass="list-group" itemclass="list-group-item"
      template="true" template-name="Action List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list"
      statehandler="none" name="EmployeeList1" dataset="bind:Variables.dbEmployeesList.dataSet"
      navigation="None"><wm-listtemplate layout="inline" name="listtemplate16"><wm-container
              class="media-left" name="container45"><wm-picture width="32pt" height="32pt" name="Picture"
                  shape="circle" picturesource="bind:Variables.dbEmployeesList.dataSet[$i].picurl"
                  class="media-object"></wm-picture></wm-container><wm-container class="media-body"
              padding="unset unset unset 1.25em" name="container46"><wm-label name="Name"
                  class="p media-heading" caption="bind:Variables.dbEmployeesList.dataSet[$i].firstname"
                  fontsize="1.143" fontunit="em"></wm-label><wm-label name="JobTitle"
                  caption="bind:Variables.dbEmployeesList.dataSet[$i].jobTitle"
                  class="p text-muted"></wm-label></wm-container><wm-container class="media-right media-top"
              name="container47"><wm-button type="button" class="btn-transparent"
                  iconclass="wi wi-share fa-2x"
                  name="button6"></wm-button></wm-container></wm-listtemplate></wm-list>`], 
      platforms: {
                    native_mobile: {
                      customTemplate: [`<wm-list listclass="list-group" itemclass="list-group-item" template="true"
                            template-name="Text with Avatar List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list"
                            statehandler="URL" name="supportedLocaleList1" dataset="bind:Variables.supportedLocale.dataSet"
                            navigation="Pager" subheading="subHeading" title="Title">
                            <wm-listtemplate layout="inline" name="listtemplate1">
                            </wm-listtemplate>
                        </wm-list>`],
                    }
                  }
    }
  },
  'wm-list-item': {
    "widgetType": "wm-list-item",
    "template": "<wm-list-item></wm-list-item>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "list",
  },
  'wm-nav': {
    "widgetType": "wm-nav",
    "template":
      "<wm-nav type='pills' autoclose='outsideClick'>" +
      "<wm-nav-item>" +
      "<wm-anchor caption='Link 1'></wm-anchor>" +
      "</wm-nav-item>" +
      "<wm-nav-item>" +
      "<wm-anchor caption='Link 2'></wm-anchor>" +
      "</wm-nav-item>" +
      "<wm-nav-item>" +
      "<wm-anchor caption='Link 3'></wm-anchor>" +
      "</wm-nav-item>" +
      "</wm-nav>",
    "platforms": {
      "native_mobile": {
        "template":
          "<wm-nav type='pills' layout='stacked'  autoclose='outsideClick'>" +
          "<wm-nav-item>" +
          "<wm-anchor caption='Link 1'></wm-anchor>" +
          "</wm-nav-item>" +
          "<wm-nav-item>" +
          "<wm-anchor caption='Link 2'></wm-anchor>" +
          "</wm-nav-item>" +
          "<wm-nav-item>" +
          "<wm-anchor caption='Link 3'></wm-anchor>" +
          "</wm-nav-item>" +
          "</wm-nav>"
      }
    },
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": false,
    "tokenFileName": "nav",
    "styleWorkspaceTemplates": {
      "platforms": {
        "native_mobile": {
          "customTemplate": [`<wm-nav type='pills' layout='stacked'  autoclose='outsideClick'>
          <wm-nav-item>
         <wm-anchor caption="New Post" iconclass="wi wi-plus" name="anchor1"></wm-anchor>
          </wm-nav-item>
          <wm-nav-item>
 <wm-anchor caption="Bookmark" iconclass="wi wi-bookmark" name="anchor2"></wm-anchor>          </wm-nav-item>
          <wm-nav-item>
<wm-anchor caption="Settings" name="anchor4" badgevalue="4"></wm-anchor>          </wm-nav-item>
          </wm-nav>`]
        }
      }
    }
  },
  'wm-nav-item': {
    "widgetType": "wm-nav-item",
    "template": "<wm-nav-item></wm-nav-item>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "navitem",
    "styleWorkspaceTemplates": {
      "platforms": {
        "native_mobile": {
          "customTemplate": [`<wm-nav type='pills' layout='stacked'  autoclose='outsideClick'>
          <wm-nav-item>
         <wm-anchor caption="New Post" iconclass="wi wi-plus" name="anchor1"></wm-anchor>
          </wm-nav-item>
          <wm-nav-item>
 <wm-anchor caption="Bookmark" iconclass="wi wi-bookmark" name="anchor2"></wm-anchor>          </wm-nav-item>
          <wm-nav-item>
<wm-anchor caption="Settings" name="anchor4" badgevalue="4"></wm-anchor>          </wm-nav-item>
          </wm-nav>`]
        }
      }
    }
  },
  'wm-navbar': {
    "widgetType": "wm-navbar",
    "template": "<wm-navbar title='Brand'>" +
      "<wm-nav type='navbar' class='navbar-left'>" +
      "<wm-nav-item><wm-anchor caption='Link 1'></wm-anchor></wm-nav-item>" +
      "<wm-nav-item><wm-anchor caption='Link 2'></wm-anchor></wm-nav-item>" +
      "<wm-nav-item><wm-anchor caption='Link 3'></wm-anchor></wm-nav-item>" +
      "</wm-nav>" +
      "<wm-nav type='navbar' class='navbar-right'>" +
      "<wm-nav-item><wm-anchor caption='Link 1'></wm-anchor></wm-nav-item>" +
      "<wm-nav-item><wm-anchor caption='Link 2'></wm-anchor></wm-nav-item>" +
      "<wm-nav-item><wm-anchor caption='Link 3'></wm-anchor></wm-nav-item>" +
      "</wm-nav>" +
      "</wm-navbar>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": false
  },
  'wm-panel': {
    "widgetType": "wm-panel",
    "template": "<wm-panel subheading='subheading' iconclass='wi wi-account-circle' autoclose='outsideClick' title='Title'>" +
      "<wm-panel-footer>" +
      "<wm-label padding='unset 0.5em' class='text-muted' caption='Addition Info'></wm-label>" +
      "</wm-panel-footer>" +
      "</wm-panel>",
    "platforms": {
      "native_mobile": {
        "template": "<wm-panel subheading='subheading' iconclass='wi wi-account-circle' autoclose='outsideClick' title='Title'>" +
          "<wm-panel-footer>" +
          "<wm-label padding='unset 4px' class='text-muted' caption='Addition Info'></wm-label>" +
          "</wm-panel-footer>" +
          "</wm-panel>"
      }
    },
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": true,
    "isPageContainer": true,
    "tokenFileName": "panel"
  },
  'wm-panel-footer': {
    "widgetType": "wm-panel-footer",
    "template": "<wm-panel-footer></wm-panel-footer>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": false,
    "isPageContainer": false,
    tokenFileName: "panel-footer",
    styleWorkspaceTemplates: {
          customTemplate: [`<wm-panel><wm-panel-footer> <wm-label padding='unset 0.5em' caption='Addition Info'></wm-label></wm-panel-footer></wm-panel>`]
    }
  },
  'wm-card': {
    "widgetType": "wm-card",
    "template": "<wm-list listclass='list-group' itemclass='list-group-item'><wm-listtemplate layout='panel' statehandler='URL'></wm-listtemplate></wm-list>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "cards",
    "config": {
      'requireVariable': true,
      'title': 'Cards',
      'bindTypes': ['wm-livefilter', 'wm-list', 'wm-table', 'wm-chart', 'wm-prefab'],
      'screens': [
        {
          "id": 'cards-config',
          "label": "Template",
          "screen": "templateConfig",
          "liveWidgetId": "wm-list",
          "description": "MESSAGE_WIDGET_SELECT_TEMPLATE",
          "templates": [
            {
              "id": "text-card",
              "title": "Text",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Text Card" itemsperrow="xs-1 sm-2 md-3 lg-4" class="list-card" statehandler="URL" navigation="Basic">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content padding="24px">' +
                '<wm-container direction="column" alignment="middle-left">' +
                '<wm-container direction="row" gap="auto" alignment="middle-center">' +
                '<wm-container width="fill" flexgrow="1">' +
                '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold" margin="0px"></wm-label>' +
                '</wm-container>' +
                '<wm-container width="25px">' +
                '<wm-icon iconclass="wi wi-more-vert" iconsize="22px"></wm-icon>' +
                '</wm-container>' +
                '</wm-container>' +
                '<wm-label name="SubTitle" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '<wm-container padding="18px unset unset unset">' +
                '<wm-label name="Description_Heading" caption="Description:" class="h5" margin="0px" fontweight="bold"></wm-label>' +
                '</wm-container>' +
                '<wm-container padding="4px unset unset unset">' +
                '<wm-label name="Description" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-container' +
                '</wm-container>' +
                '</wm-card-content>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "text-with-action-card",
              "title": "Text With Action",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
               "template": ' <wm-list listclass="list-group" template="true" template-name="Text with Action Card" itemsperrow="xs-1 sm-2 md-3 lg-4" class="list-card" statehandler="URL" navigation="Basic">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content padding="24px">' +
                '<wm-container direction="column" alignment="middle-left">' +
                '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold" margin="0px"></wm-label>' +
                '<wm-label name="SubTitle" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '<wm-container padding="18px unset unset unset">' +
                '<wm-label name="Description_Heading" caption="Description:" margin="0px" class="h5" fontweight="bold"></wm-label>' +
                '</wm-container>' +
                '<wm-container padding="4px unset unset unset">' +
                '<wm-label name="Description" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-container>' +
                '</wm-container>' +
                '</wm-card-content>' +
                '<wm-card-footer padding="16px 24px" horizontalalign="right">' +
                '<wm-container direction="column">' +
                '<wm-button class="btn-primary" textalign="center" caption="Action" padding="8px 24px"></wm-button>' +
                '</wm-container>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "media-card",
              "title": "Media",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
                "template": '<wm-list listclass="list-group" template="true" template-name="Media Card" itemsperrow="xs-1 sm-2 md-3 lg-4" class="list-card" statehandler="URL" navigation="Basic">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content padding="0px">' +
                '<wm-container direction="column" alignment="middle-left">' +
                '<wm-picture name="Picture" picturesource="{}" data-is-target shape="rounded" resizemode="cover" class="img-responsive" width="100%"></wm-picture>' +
                '<wm-container direction="column" alignment="middle-left" padding="24px">' +
                '<wm-container direction="row" gap="auto" alignment="middle-center">' +
                '<wm-container width="fill">' +
                '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold" margin="0px"></wm-label>' +
                 '</wm-container>' +
                '<wm-container width="25px">' +
                '<wm-icon iconclass="wi wi-more-vert" iconsize="22px" iconposition="left"></wm-icon>' +
                '</wm-container>' +
                '</wm-container>' +
                '<wm-label name="SubTitle" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '<wm-container padding="18px unset unset unset">' +
                '<wm-label name="Description_Heading" caption="Description:" class="h5" margin="0px" fontweight="bold"></wm-label>' +
                '</wm-container>' +
                '<wm-container padding="4px unset unset unset">' +
                '<wm-label name="Description" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-container>' +
                '</wm-container>' + 
                '</wm-container>' + 
                '</wm-card-content>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "media-with-action-card",
              "title": "Media with Action",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Media with Action Card" itemsperrow="xs-1 sm-2 md-3 lg-4" class="list-card" statehandler="URL" navigation="Basic">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content padding="0px">' +
                '<wm-container direction="column" alignment="left-center">' +
                '<wm-picture name="Picture" picturesource="{}" data-is-target shape="rounded" resizemode="cover" class="img-responsive" width="100%"></wm-picture>' +
                '<wm-container direction="column" alignment="left-center" padding="24px">' +
                '<wm-container direction="column" alignment="left-center" padding="24px">' +
                '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold" margin="0px"></wm-label>' +
                '<wm-label name="SubTitle" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-container>' +
                '<wm-container padding="18px unset unset unset">' +
                '<wm-label name="Description_Heading" caption="Description:" class="h5" margin="0px" fontweight="bold"></wm-label>' +
                '<wm-label name="Description" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-container>' +
                '</wm-container>' +
                '</wm-card-content>' +
                '<wm-card-footer name="card_footer1" padding="16px 24px" horizontalalign="right">' +
                '<wm-container direction="row" gap="10">' +
                '<wm-button class="btn-primary" textalign="center" caption="Action1" padding="8px 24px"></wm-button>' +
                '<wm-button class="btn-secondary" textalign="center" caption="Action2" padding="8px 24px"></wm-button>' +
                '</wm-container>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "bussiness-card",
              "title": "Business Card",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Business Card" itemsperrow="xs-1 sm-2 md-3 lg-4" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content fontsize="0.8" fontunit="em">' +
                '<wm-layoutgrid columns="2">' +
                '<wm-gridrow>' +
                '<wm-gridcolumn colwidth="6" columnwidth="6" class="col-xs-6">' +
                '<wm-picture name="Picture" width="100%" data-is-target picturesource="{}" aspect-ratio="4:3 or 1:1"></wm-picture>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn colwidth="6" columnwidth="6" padding="unset 1.25em" class="col-xs-6">' +
                '<wm-label name="ID" data-is-target caption="{}" class="text-muted p" margin="unset unset 0px unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="Name" data-is-target caption="{}" class="h4" margin="0px unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="JobTitle" data-is-target caption="{}" class="h5" margin="0px unset unset unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="Department" data-is-target caption="{}" class="p text-muted" name="label7" margin="unset unset 0px unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="Location" data-is-target caption="{}" class="text-muted p" whitespace="nowrap"></wm-label>' +
                '<wm-anchor name="PhoneNumber" data-is-target caption="{}" class="h5" hyperlink="tel:" margin="0px unset" whitespace="nowrap"></wm-anchor>' +
                '<wm-anchor name="EmailID" class="p text-muted" hyperlink="mailto://" data-is-target caption="{}" whitespace="nowrap"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '</wm-card-content>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "contact-card",
              "title": "Contact Card",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" itemsperrow="xs-2 sm-4 md-6 lg-6" template="true" template-name="Contact Card" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="ContactCard">' +
                '<wm-card-content horizontalalign="center">' +
                '<wm-layoutgrid>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn columnwidth="12" horizontalalign="center">' +
                '<wm-picture name="Picture" shape="circle" data-is-target picturesource="{}" width="60%"></wm-picture>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '<wm-label name="Name" class="h4 text-center" margin="unset unset 0em unset"  data-is-target caption="{}" whitespace="nowrap"></wm-label>' +
                '<wm-label name="JobTitle" class="p text-muted  text-center" data-is-target caption="{}" whitespace="nowrap"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-buttongroup class="btn-group-justified" horizontalalign="center">' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-mail fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-call fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-location-on fa-2x"></wm-anchor>' +
                '</wm-buttongroup>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "designation-card",
              "title": "Designation Card",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" itemsperrow="xs-2 sm-3 md-4 lg-6" template="true" template-name="Designation Card" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Picture" data-is-target picturesource="{}" aspect-ratio="4:3 or 1:1">' +
                '<wm-card-content>' +
                '<wm-label name="Name" class="h4" margin="0px unset" data-is-target caption="{}" whitespace="nowrap"></wm-label>' +
                '<wm-label name="JobTitle" class="p text-muted"  data-is-target caption="{}" whitespace="nowrap"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer>' +
                '<wm-buttongroup class="btn-group-justified" horizontalalign="center">' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-mail fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-call fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-location-on fa-2x"></wm-anchor>' +
                '</wm-buttongroup>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "i-card",
              "title": "I Card",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="I Card" itemsperrow="xs-1 sm-2 md-4 lg-6" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Picture" data-is-target picturesource="{}" aspect-ratio="16:9 or 1:1">' +
                '<wm-card-content>' +
                '<wm-label data-is-target caption="{}" name="Name" margin="0px unset unset unset"  class="h4" whitespace="nowrap"></wm-label>' +
                '<wm-layoutgrid columns="2">' +
                '<wm-gridrow>' +
                '<wm-gridcolumn colwidth="6" columnwidth="2" horizontalalign="left">' +
                '<wm-icon iconclass="wi wi-contact-mail fa-2x" class="text-muted"></wm-icon>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn colwidth="6" padding="unset unset unset 1.25em">' +
                '<wm-label name="ID" data-is-target caption="{}" fontunit="em" class="text-muted p" whitespace="nowrap"></wm-label>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn colwidth="6" columnwidth="2" horizontalalign="left">' +
                '<wm-icon iconclass="wi wi-user fa-2x" class="text-muted"></wm-icon>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn colwidth="6" padding="unset unset unset 1.25em">' +
                '<wm-label name="JobTitle" data-is-target caption="{}" fontunit="em" class="text-muted p"></wm-label>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn colwidth="6" columnwidth="2" horizontalalign="left">' +
                '<wm-icon iconclass="wi wi-dashboard fa-2x" class="text-muted"></wm-icon>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn colwidth="6" padding="unset unset unset 1.25em">' +
                '<wm-label name="Department" data-is-target caption="{}" fontunit="em" class="text-muted"></wm-label>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-buttongroup class="btn-group-justified" horizontalalign="center">' +
                '<wm-anchor class="btn btn-transparent text-muted" caption="" iconclass="wi wi-mail fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-call fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-location-on fa-2x"></wm-anchor>' +
                '</wm-buttongroup>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "product-overview",
              "title": "Product Overview",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Product Overview" itemsperrow="xs-1 sm-2 md-4 lg-4" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Picture" data-is-target picturesource="{}" title="{}" subheading="{}" aspect-ratio="16:9 or 1:1">' +
                '<wm-card-content padding="1.5em unset unset unset">' +
                '<wm-button class="btn-fab btn-warning pull-right btn-lg" caption="" type="button" name="button2" iconclass="wi wi-cart" margin="-3.5em 0.5em unset unset"></wm-button>' +
                '<wm-layoutgrid>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn columnwidth="6" horizontalalign="left" class="col-xs-6">' +
                '<wm-label name="Price"  data-is-target caption="{}" fontsize="1.286" fontunit="em"></wm-label>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn columnwidth="6" horizontalalign="right" class="col-xs-6">' +
                '<wm-label name="Quantity" data-is-target fontsize="1.286" fontunit="em" caption="{}" margin="unset 0.2em unset unset"></wm-label>' +
                '<wm-label name="HelpText" caption="Available"></wm-label>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '<wm-label name="Description" data-is-target class="p text-muted" caption="{}"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-anchor caption="VIEW ALL SPECIFICATIONS" class="btn btn-transparent"></wm-anchor>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "product-thumbnail",
              "title": "Product Thumbnail",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Product Thumbnail" itemsperrow="xs-1 sm-2 md-4 lg-4" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Thumbnail" data-is-target picturesource="{}" aspect-ratio="16:9 or 1:1">' +
                '<wm-card-content>' +
                '<wm-label name="Name" data-is-target caption="{}" fontsize="1.286" fontunit="em" margin="unset 0.2em unset unset"></wm-label>' +
                '<wm-label name="Model" data-is-target caption="{}" class="text-muted"></wm-label>' +
                '<wm-layoutgrid>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn columnwidth="6" horizontalalign="left" class="col-xs-6">' +
                '<wm-label name="Currency" data-is-target caption="{}" color="#ba5d1e"></wm-label>' +
                '<wm-label name="Price" data-is-target caption="{}" fontsize="1.571" fontunit="em" color="#ba5d1e" margin="unset unset 1px unset"></wm-label>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn columnwidth="6" horizontalalign="right" class="col-xs-6">' +
                '<wm-label name="Quantity" fontsize="1.286" fontunit="em" data-is-target caption="{}" margin="unset 0.2em unset unset"></wm-label>' +
                '<wm-label name="HelpText" caption="Available"></wm-label>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-anchor caption="ADD TO CART" class="btn btn-transparent text-warning"></wm-anchor>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "product-inventory",
              "title": "Product Inventory",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Product Inventory" itemsperrow="xs-1 sm-2 md-4 lg-4" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Picture" data-is-target picturesource="{}" aspect-ratio="16:9 or 1:1">' +
                '<wm-card-content>' +
                '<wm-label name="Name" class="h4" data-is-target caption="{}" margin="unset unset 0px unset"></wm-label>' +
                '<wm-label name="Model" data-is-target caption="{}" class="p text-muted"></wm-label>' +
                '<wm-label name="Quantity" data-is-target fontsize="1.286" fontunit="em" caption="{}" margin="unset 0.2em unset unset"></wm-label>' +
                '<wm-label name="HelpText" caption="Available"></wm-label>' +
                '<wm-label name="Description" data-is-target class="p text-muted" caption="{}"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-anchor caption="VIEW ALL SPECIFICATIONS" class="btn btn-transparent"></wm-anchor>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "media-post",
              "title": "Media Post",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Media Post" itemsperrow="xs-1 sm-2 md-2 lg-3" class="media list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-container>' +
                '<wm-container class="media-left" padding="unset unset unset 0.5em">' +
                '<wm-picture shape="circle" name="Avatar" data-is-target width="32pt" height="32pt" picturesource="{}" aspect-ratio="16:9 or 1:1"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body">' +
                '<wm-label class="h4" caption="{}" data-is-target name="Name" margin="0px unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="Date" data-is-target caption="{}" class="p text-muted" whitespace="nowrap" margin="0px unset unset unset"></wm-label>' +
                '</wm-container>' +
                '<wm-card name="Picture" data-is-target picturesource="{}">' +
                '<wm-card-content name="card_content1" padding="1.25em">' +
                '<wm-label caption="{}" data-is-target name="Title" margin="0px unset unset unset" fontunit="em" class="h4"></wm-label>' +
                '<wm-label name="Description" data-is-target class="p text-muted" whitespace="nowrap" caption="{}" margin="unset unset 1em unset"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer>' +
                '<wm-layoutgrid>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn columnwidth="4" class="col-xs-4">' +
                '<wm-anchor class="text-warning" caption="READ MORE"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn columnwidth="8" horizontalalign="right" class="col-xs-8">' +
                '<wm-anchor iconclass="wi wi-share fa-2x" class="btn btn-transparent" caption="75" margin="unset 1em unset unset"></wm-anchor>' +
                '<wm-anchor iconclass="wi wi-comments fa-2x" caption="50" class="btn btn-transparent"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "news-post",
              "title": "News Post",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="News Post" itemsperrow="xs-1 sm-2 md-2 lg-3" class="media list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-container>' +
                '<wm-container class="media-left" padding="unset unset unset 0.5em">' +
                '<wm-picture shape="circle" data-is-target name="Avatar" width="32pt" height="32pt" picturesource="{}" aspect-ratio="16:9 or 1:1"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body">' +
                '<wm-label class="h4" data-is-target caption="{}" name="Name" margin="0px unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="Date" data-is-target caption="{}" class="p text-muted" whitespace="nowrap" margin="0px unset unset unset"></wm-label>' +
                '</wm-container>' +
                '<wm-card>' +
                '<wm-card-content padding="2em">' +
                '<wm-label caption="{}" data-is-target name="Title" margin="0px unset unset unset" fontunit="em" class="h4"></wm-label>' +
                '<wm-label name="Description" class="p" data-is-target caption="{}"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer>' +
                '<wm-layoutgrid>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn columnwidth="4" class="col-xs-4">' +
                '<wm-anchor caption="READ MORE"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn columnwidth="8" horizontalalign="right" class="col-xs-8">' +
                '<wm-anchor iconclass="wi wi-share fa-2x" class="btn btn-transparent" caption="425" margin="unset 1em unset unset"></wm-anchor>' +
                '<wm-anchor iconclass="wi wi-thumb-up fa-2x" class="btn btn-transparent" caption="75" margin="unset 1em unset unset"></wm-anchor>' +
                '<wm-anchor iconclass="wi wi-comments fa-2x" caption="50" class="btn btn-transparent"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "personal-spotlight",
              "title": "Personal Spotlight",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" itemsperrow="xs-1 sm-2 md-3 lg-4" template="true" template-name="Personal Spotlight"  class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Picture" data-is-target picturesource="{}" aspect-ratio="16:9 or 1:1">' +
                '<wm-card-content padding="1.25em">' +
                '<wm-label name="Name" class="h4 text-muted" width="100%" data-is-target caption="{}" whitespace="nowrap" margin="0px unset unset unset"></wm-label>' +
                '<wm-label name="Title" data-is-target caption="{}" class="h4" margin="0px unset unset unset"></wm-label>' +
                '<wm-label name="Description" data-is-target caption="{}" class="p text-muted" margin="0px unset unset unset"></wm-label>' +
                '<wm-layoutgrid>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn columnwidth="6" class="col-xs-6">' +
                '<wm-label name="Date" data-is-target caption="{}" class="text-muted" margin="0.6em unset unset unset" fontsize="1.143" fontunit="em"></wm-label>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn columnwidth="6" horizontalalign="right" class="col-xs-6">' +
                '<wm-anchor class="btn btn-transparent" iconclass="wi wi-comments fa-2x" caption="50"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-layoutgrid>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn columnwidth="4" horizontalalign="left" class="col-xs-4">' +
                '<wm-anchor caption="75" iconclass="wi wi-share fa-2x" class="btn btn-transparent"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn columnwidth="4" horizontalalign="center" class="col-xs-4">' +
                '<wm-anchor caption="425" iconclass="wi wi-share fa-2x" class="btn btn-transparent"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn columnwidth="4" horizontalalign="right" class="col-xs-4">' +
                '<wm-anchor caption="60" iconclass="wi wi-remove-red-eye fa-2x" class="btn btn-transparent"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            }
          ]
        },
        {
          "id": 'card-fields',
          "label": "Bind Fields",
          "screen": "liveListFieldConfig",
          "description": "MESSAGE_WIDGET_MAP_FIELDS",
          "liveWidgetId": "wm-list"
        }
      ]
    }, 
  },
  'wm-card-footer': {
    "widgetType": "wm-card-footer",
    "template": "<wm-card-footer></wm-card-footer>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": false,
    "isPageContainer": false
  },
  'wm-card-actions': {
    "widgetType": "wm-card-actions",
    "template": "<wm-card-actions></wm-card-actions>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": false,
    "isPageContainer": false
  },
  'wm-card-content': {
    "widgetType": "wm-card-content",
    "template": "<wm-card-content></wm-card-content>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": false,
    "parent": "wm-card",
    "isPageContainer": true
  },
  'wm-tabs': {
    "widgetType": "wm-tabs",
    "template":
      "<wm-tabs type='static' statehandler='URL'>" +
      "<wm-tabpane title='Tab title'></wm-tabpane>" +
      "<wm-tabpane title='Tab title'></wm-tabpane>" +
      "<wm-tabpane title='Tab title'></wm-tabpane>" +
      "</wm-tabs>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "tabs", 
    styleWorkspaceTemplates : {
      usageTemplate :  `<wm-layoutgrid name="layoutgrid1">
      <wm-gridrow name="gridrow6">
          <wm-gridcolumn columnwidth="4" name="gridcolumn10">
              <wm-label padding="unset" class="h5" type="h5" name="label6" caption="Tabs Position - Top(default)"></wm-label>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-container name="container1" class="app-elevated-container" style="padding: 12px; margin: 10px 0;">
          <wm-gridrow name="gridrow2">
              <wm-gridcolumn columnwidth="12" name="gridcolumn4">
                  <wm-tabs type="static" statehandler="none" name="tabs1" iconposition="left" tabsposition="top" [showlist]="false">
                      <wm-tabpane name="tabpane1">
                          <wm-label padding="unset" class="p" type="p" name="label13_1" caption="tab content 1"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane name="tabpane2" paneicon="wi wi-account-circle" title="">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 2" name="label14"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane name="tabpane3" title="Tab Title" paneicon="wi wi-account-circle">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 3" name="label16"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane name="tabpane23" title="Disabled" paneicon="wi wi-account-circle" disabled="true">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 4" name="label15"></wm-label>
                      </wm-tabpane>
                  </wm-tabs>
              </wm-gridcolumn>
          </wm-gridrow>
      </wm-container>
      <wm-gridrow name="gridrow6">
          <wm-gridcolumn columnwidth="4" name="gridcolumn10">
              <wm-label padding="unset" class="h5" type="h5" name="label6" caption="Tabs Position - Left"></wm-label>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-container name="container2" class="app-elevated-container" style="padding: 12px; margin: 10px 0;">
          <wm-gridrow name="gridrow3">
              <wm-gridcolumn columnwidth="12" name="gridcolumn5">
                  <wm-tabs type="static" statehandler="none" iconposition="left" tabsposition="left" name="tabs10" [showlist]="false">
                      <wm-tabpane name="tabpane28">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 1" name="label21"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane paneicon="wi wi-account-circle" title="" name="tabpane29">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 2" name="label22"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane title="Tab Title" paneicon="wi wi-account-circle" name="tabpane30">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 3" name="label23"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane title="Disabled" paneicon="wi wi-account-circle" disabled="true" name="tabpane31">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 4" name="label24"></wm-label>
                      </wm-tabpane>
                  </wm-tabs>
              </wm-gridcolumn>
          </wm-gridrow>
      </wm-container>
      <wm-gridrow name="gridrow6">
          <wm-gridcolumn columnwidth="4" name="gridcolumn10">
              <wm-label padding="unset" class="h5" type="h5" name="label6" caption="Tabs Position - Right"></wm-label>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-container name="container3" class="app-elevated-container" style="padding: 12px; margin: 10px 0;">
          <wm-gridrow name="gridrow4">
              <wm-gridcolumn columnwidth="12" name="gridcolumn7">
                  <wm-tabs type="static" statehandler="none" iconposition="left" tabsposition="right" name="tabs9" [showlist]="false">
                      <wm-tabpane name="tabpane25_1">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 1" name="label21_1"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane paneicon="wi wi-account-circle" title="" name="tabpane26">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 2" name="label22_1"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane title="Tab Title" paneicon="wi wi-account-circle" name="tabpane27">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 3" name="label23_1"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane title="Disabled" paneicon="wi wi-account-circle" disabled="true" name="tabpane28_1">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 4" name="label24_1"></wm-label>
                      </wm-tabpane>
                  </wm-tabs>
              </wm-gridcolumn>
          </wm-gridrow>
      </wm-container>
      <wm-gridrow name="gridrow6">
          <wm-gridcolumn columnwidth="4" name="gridcolumn10">
              <wm-label padding="unset" class="h5" type="h5" name="label6" caption="Tabs Position - Bottom"></wm-label>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-container name="container4" class="app-elevated-container" style="padding: 12px; margin: 10px 0;">
          <wm-gridrow name="gridrow5">
              <wm-gridcolumn columnwidth="12" name="gridcolumn9">
                  <wm-tabs type="static" statehandler="none" iconposition="left" tabsposition="bottom" name="tabs9_1" [showlist]="false">
                      <wm-tabpane name="tabpane26_1">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 1" name="label25"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane paneicon="wi wi-account-circle" title="" name="tabpane27_1">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 2" name="label26"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane title="Tab Title" paneicon="wi wi-account-circle" name="tabpane28_2">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 3" name="label27"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane title="Disabled" paneicon="wi wi-account-circle" disabled="true" name="tabpane29_1">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 4" name="label28"></wm-label>
                      </wm-tabpane>
                  </wm-tabs>
              </wm-gridcolumn>
          </wm-gridrow>
      </wm-container>
      <wm-gridrow name="gridrow6">
          <wm-gridcolumn columnwidth="4" name="gridcolumn10">
              <wm-label padding="unset" class="h5" type="h5" name="label6" caption="Icon Position - Left(Default)"></wm-label>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-container name="container5" class="app-elevated-container" style="padding: 12px; margin: 10px 0;">
          <wm-gridrow name="gridrow7">
              <wm-gridcolumn columnwidth="12" name="gridcolumn13">
                  <wm-tabs type="static" statehandler="none" iconposition="left" tabsposition="top" name="tabs9_2" [showlist]="false">
                      <wm-tabpane name="tabpane27_2">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 1" name="label29"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane paneicon="wi wi-account-circle" title="" name="tabpane28_3">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 2" name="label30"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane title="Tab Title" paneicon="wi wi-account-circle" name="tabpane29_2">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 3" name="label31"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane title="Disabled" paneicon="wi wi-account-circle" disabled="true" name="tabpane30_1">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 4" name="label32"></wm-label>
                      </wm-tabpane>
                  </wm-tabs>
              </wm-gridcolumn>
          </wm-gridrow>
      </wm-container>
      <wm-gridrow name="gridrow6">
          <wm-gridcolumn columnwidth="4" name="gridcolumn10">
              <wm-label padding="unset" class="h5" type="h5" name="label6" caption="Icon Position - Right"></wm-label>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-container name="container6" class="app-elevated-container" style="padding: 12px; margin: 10px 0;">
          <wm-gridrow name="gridrow8">
              <wm-gridcolumn columnwidth="12" name="gridcolumn15">
                  <wm-tabs type="static" statehandler="none" iconposition="right" tabsposition="top" name="tabs10_1" [showlist]="false">
                      <wm-tabpane name="tabpane31_1">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 1" name="label33"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane paneicon="wi wi-account-circle" title="" name="tabpane32">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 2" name="label34"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane title="Tab Title" paneicon="wi wi-account-circle" name="tabpane33">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 3" name="label35"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane title="Disabled" paneicon="wi wi-account-circle" disabled="true" name="tabpane34">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 4" name="label36"></wm-label>
                      </wm-tabpane>
                  </wm-tabs>
              </wm-gridcolumn>
          </wm-gridrow>
      </wm-container>
      <wm-gridrow name="gridrow6">
          <wm-gridcolumn columnwidth="4" name="gridcolumn10">
              <wm-label padding="unset" class="h5" type="h5" name="label6" caption="Icon Position - Top"></wm-label>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-container name="container7" class="app-elevated-container" style="padding: 12px; margin: 10px 0;">
          <wm-gridrow name="gridrow9">
              <wm-gridcolumn columnwidth="12" name="gridcolumn17">
                  <wm-tabs type="static" statehandler="none" iconposition="top" tabsposition="top" name="tabs11" [showlist]="false">
                      <wm-tabpane name="tabpane35">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 1" name="label37"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane paneicon="wi wi-account-circle" title="" name="tabpane36">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 2" name="label38"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane title="Tab Title" paneicon="wi wi-account-circle" name="tabpane37">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 3" name="label39"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane title="Disabled" paneicon="wi wi-account-circle" disabled="true" name="tabpane38">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 4" name="label40"></wm-label>
                      </wm-tabpane>
                  </wm-tabs>
              </wm-gridcolumn>
          </wm-gridrow>
      </wm-container>
      <wm-gridrow name="gridrow14">
          <wm-gridcolumn columnwidth="4" name="gridcolumn25">
              <wm-label padding="unset" class="h5" type="h5" caption="Data Type - Static(default)" name="label41"></wm-label>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-container name="container8" class="app-elevated-container" style="padding: 12px; margin: 10px 0;">
          <wm-gridrow name="gridrow10">
              <wm-gridcolumn columnwidth="12" name="gridcolumn19">
                  <wm-tabs type="static" statehandler="none" iconposition="left" tabsposition="top" name="tabs12" [showlist]="false">
                      <wm-tabpane name="tabpane39">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 1" name="label43"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane paneicon="wi wi-account-circle" title="" name="tabpane40">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 2" name="label44"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane title="Tab Title" paneicon="wi wi-account-circle" name="tabpane41">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 3" name="label45"></wm-label>
                      </wm-tabpane>
                      <wm-tabpane title="Disabled" paneicon="wi wi-account-circle" disabled="true" name="tabpane42">
                          <wm-label padding="unset" class="p" type="p" caption="tab content 4" name="label46"></wm-label>
                      </wm-tabpane>
                  </wm-tabs>
              </wm-gridcolumn>
          </wm-gridrow>
      </wm-container>
      <wm-gridrow name="gridrow14">
          <wm-gridcolumn columnwidth="4" name="gridcolumn25">
              <wm-label padding="unset" class="h5" type="h5" caption="Data Type - Dynamic" name="label41"></wm-label>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-container name="container9" class="app-elevated-container" style="padding: 12px; margin: 10px 0;">
          <wm-gridrow name="gridrow11">
              <wm-gridcolumn columnwidth="12" name="gridcolumn21">
                  <wm-tabs type="dynamic" statehandler="none" name="tabs13" dataset="bind:Variables.HrdbDepartmentData.dataSet" iconposition="left" [showlist]="false">
                      <wm-repeat-template name="repeat_template2">
                          <wm-tabpane name="tabpane47" title="bind:Variables.HrdbDepartmentData.dataSet[$i].name"></wm-tabpane>
                      </wm-repeat-template>
                  </wm-tabs>
              </wm-gridcolumn>
          </wm-gridrow>
      </wm-container>
  </wm-layoutgrid>`, 
  customTemplate :  [`<wm-tabs type="static" statehandler="none" name="tabs1" iconposition="left" tabsposition="top" [showlist]="false">
  <wm-tabpane name="tabpane1">
      <wm-label padding="unset" class="p" type="p" name="label13_1" caption="tab content 1"></wm-label>
  </wm-tabpane>
  <wm-tabpane name="tabpane2" paneicon="wi wi-account-circle" title="">
      <wm-label padding="unset" class="p" type="p" caption="tab content 2" name="label14"></wm-label>
  </wm-tabpane>
  <wm-tabpane name="tabpane3" title="Tab Title" paneicon="wi wi-account-circle">
      <wm-label padding="unset" class="p" type="p" caption="tab content 3" name="label16"></wm-label>
  </wm-tabpane>
  <wm-tabpane name="tabpane23" title="Disabled" paneicon="wi wi-account-circle" disabled="true">
      <wm-label padding="unset" class="p" type="p" caption="tab content 4" name="label15"></wm-label>
  </wm-tabpane>
</wm-tabs>`],
      "platforms": {
        "native_mobile": {
          usageTemplate: `  <wm-tabs type="static" statehandler="URL" name="tabs1">
                <wm-tabpane title="Tab 1" name="tabpane1"></wm-tabpane>
                <wm-tabpane title="Tab 2" name="tabpane2"></wm-tabpane>
                <wm-tabpane title="Tab 3" name="tabpane3"></wm-tabpane>
                <wm-tabpane title="Tab 4" name="tabpane4"></wm-tabpane>
            </wm-tabs>`
        }
      }
    }
  },
  'wm-tabpane': {
    "widgetType": "wm-tabpane",
    "template":
      "<wm-tabpane title='Tab title'></wm-tabpane>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": false,
    "isPageContainer": true
  },
  'wm-wizard': {
    "widgetType": "wm-wizard",
    "template":
      "<wm-wizard type='static' stepstyle='justified' class='number'>" +
      "<wm-wizardstep></wm-wizardstep>" +
      "<wm-wizardstep></wm-wizardstep>" +
      "<wm-wizardstep></wm-wizardstep>" +
      "<wm-wizardaction>" +
      "<wm-anchor class='app-wizard-skip' caption='Skip &raquo;' show='bind:skippable()' on-click='skip()'></wm-anchor>" +
      "<wm-container class='app-wizard-actions-right'>" +
      "<wm-button class='btn-default app-wizard-cancel' type='button' caption='bind:cancelbtnlabel()' show='bind:cancelable()' on-click='cancel()'></wm-button>" +
      "<wm-button class='btn-default app-wizard-previous' type='button' iconclass='wi wi-chevron-left' caption='bind:previousbtnlabel()' show='bind:hasPreviousStep()' on-click='previous()' disabled='bind:disablePrevious()'></wm-button>" +
      "<wm-button class='btn-primary app-wizard-next' type='button' iconclass='wi wi-chevron-right' iconposition='right' caption='bind:nextbtnlabel()' show='bind:hasNextStep()' on-click='next()' disabled='bind:disableNext()'></wm-button>" +
      "<wm-button class='btn-success app-wizard-done' type='button' iconclass='wi wi-check' caption='bind:donebtnlabel()' show='bind:hasNoNextStep()' on-click='done()' disabled='bind:disableDone()'></wm-button>" +
      "</wm-container>" +
      "</wm-wizardaction>" +
      "</wm-wizard>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isLayoutBundled": true,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": true,
    tokenFileName : "wizard", 
    styleWorkspaceTemplates : {
      customTemplate : [`<wm-wizard type="static" stepstyle="justified" class="number app-wizard" name="wizard1" variant="number">
      <wm-wizardstep name="wizardstep1"></wm-wizardstep>
      <wm-wizardstep name="wizardstep2"></wm-wizardstep>
      <wm-wizardstep name="wizardstep3"></wm-wizardstep>
      <wm-wizardaction name="wizardaction1">
          <wm-anchor class="app-wizard-skip" caption="Skip »" show="bind:skippable()" on-click="skip()"
              name="anchor1"></wm-anchor>
          <wm-container class="app-wizard-actions-right app-container-default" name="container4"
              variant="default">
          </wm-container>
      </wm-wizardaction>
  </wm-wizard>`]
    }

  },
  'wm-wizardstep': {
    "widgetType": "wm-wizardstep",
    "template": "<wm-wizardstep></wm-wizardstep>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": false
  },
  'wm-wizardaction': {
    widgetType: "wm-wizardaction",
    template: "<wm-wizardaction></wm-wizardaction>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": false
  },
  'wm-segmented-control': {
    "widgetType": "wm-segmented-control",
    "template": "<wm-segmented-control>" +
      "<wm-segment-content caption='Title 1'></wm-segment-content>" +
      "<wm-segment-content caption='Title 2'></wm-segment-content>" +
      "<wm-segment-content caption='Title 3'></wm-segment-content>" +
      "</wm-segmented-control>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true
  },
  'wm-segment-content': {
    "widgetType": "wm-segment-content",
    "template": "<wm-segment-content caption='Title'></wm-segment-content>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": false,
    "isPageContainer": true
  },
  'wm-mobile-tabbar': {
    "widgetType": "wm-mobile-tabbar",
    "template": "<wm-mobile-tabbar  dataset='Tab1,Tab2,Tab3,Tab4'></wm-mobile-tabbar>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName":"tabbar"
  },
  'wm-mobile-navbar': {
    "widgetType": "wm-mobile-navbar",
    "template": "<wm-mobile-navbar></wm-mobile-navbar>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName":"navbar",
    styleWorkspaceTemplates : {
     customTemplate: [`
   <wm-mobile-navbar name="mobile_navbar1" title="Title" backbutton="true">
        <wm-anchor caption="" name="AddLink" iconclass="wi wi-gear"></wm-anchor>
    </wm-mobile-navbar>`]
    }
  },
  'wm-table': {
    "widgetType": "wm-table",
    "template":
      '<wm-table>' +
      '<wm-table-column caption="Column1" pcdisplay="true" mobiledisplay="true"></wm-table-column>' +
      '<wm-table-column caption="Column2" pcdisplay="true" mobiledisplay="true"></wm-table-column>' +
      '<wm-table-column caption="Column3" pcdisplay="true" mobiledisplay="true"></wm-table-column>' +
      '<wm-table-column caption="Column4" pcdisplay="true" mobiledisplay="true"></wm-table-column>' +
      '<wm-table-column caption="Column5" pcdisplay="true" mobiledisplay="true"></wm-table-column>' +
      '</wm-table>',
    "isContainer": false,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "data-table",
    "config": {
      'requireVariable': true,
      'title': 'Data Table',
      'bindTypes': ['wm-table', 'wm-liveform', 'wm-livefilter', 'wm-list', 'wm-chart', 'wm-prefab'],
      'screens': [
        {
          "id": 'grid-template',
          "label": "Layout",
          "labelKey": "LABEL_LAYOUT",
          "screen": "templateConfig",
          "description": "MESSAGE_TEMPLATE_SELECT_WIDGET",
          "liveWidgetId": "wm-table",
          "templates": [
            {
              "id": "readonly-grid",
              "title": "Simple View only",
              "labelKey": "LABEL_SIMPLE_VIEW_ONLY",
              "platform": ["WEB", "MOBILE"],
              "isEditable": false,
              "template":
                '<wm-table statehandler="URL">' +
                '</wm-table>'
            },
            {
              "id": "editable-grid",
              "title": "Inline Editable",
              "labelKey": "LABEL_INLINE_EDITABLE",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-table editmode="inline" statehandler="URL">' +
                '</wm-table>'
            },
            {
              "id": "grid-form-dialog",
              "title": "Form as Dialog",
              "labelKey": "LABEL_FORM_AS_DIALOG",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-livetable formlayout="dialog">' +
                '<wm-table gridfirstrowselect="true" editmode="dialog" statehandler="URL"></wm-table>' +
                '<wm-liveform  errormessage="" title="Details" formlayout="dialog" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>' +
                '</wm-livetable>'
            },
            {
              "id": "crud-grid-form-dialog",
              "title": "Form as Dialog",
              "labelKey": "LABEL_FORM_AS_DIALOG",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-table gridfirstrowselect="true" editmode="dialog" statehandler="URL"></wm-table>' +
                '<wm-form  errormessage="" title="Details" formlayout="dialog" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-form>'
            },
            {
              "id": "crud-grid-form",
              "title": "Form Below",
              "labelKey": "LABEL_FORM_BELOW",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-table gridfirstrowselect="true" editmode="form" statehandler="URL"></wm-table>' +
                '<wm-form  errormessage="" title="Details" formlayout="inline" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-form>'
            },
            {
              "id": "crud-grid-form-readonly",
              "title": "Details Below",
              "labelKey": "LABEL_DETAILS_BELOW",
              "platform": ["WEB", "MOBILE"],
              "isEditable": false,
              "template":
                '<wm-table gridfirstrowselect="true" statehandler="URL"></wm-table>' +
                '<wm-form  errormessage="" title="Details" formlayout="inline" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-form>'
            },
            {
              "id": "grid-form",
              "title": "Form Below",
              "labelKey": "LABEL_FORM_BELOW",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-livetable>' +
                '<wm-table gridfirstrowselect="true" editmode="form" statehandler="URL"></wm-table>' +
                '<wm-liveform  errormessage=""  title="Details" formlayout="inline" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>' +
                '</wm-livetable>'
            },
            {
              "id": "grid-form-readonly",
              "title": "Details Below",
              "labelKey": "LABEL_DETAILS_BELOW",
              "platform": ["WEB", "MOBILE"],
              "isEditable": false,
              "template":
                '<wm-livetable>' +
                '<wm-table gridfirstrowselect="true" statehandler="URL"></wm-table>' +
                '<wm-liveform  errormessage="" title="Details" formlayout="inline" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>' +
                '</wm-livetable>'
            },
            {
              "id": "quick-inline-editable",
              "title": "Quick Edit",
              "labelKey": "LABEL_QUICK_EDIT",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-table editmode="quickedit" statehandler="URL">' +
                '</wm-table>'
            }
          ]
        },
        {
          "id": 'grid-columns',
          "label": "Table Columns",
          "labelKey": "LABEL_TABLE_COLUMNS",
          "screen": "widgetFieldConfig",
          "description": "MESSAGE_TEMPLATE_MAP_FIELDS",
          "liveWidgetId": "wm-table"
        }
      ]
    }, 
    styleWorkspaceTemplates :{
      customTemplate : [`<wm-table statehandler="none" name="normal" title="Table"
                dataset='[{"userId":"1","role":"Manager","tenantId":"321","username":"Harry"},{"userId":"2","role":"Engineer","tenantId":"322","username":"John"},{"userId":"3","role":"Engineer","tenantId":"323","username":"Jacob"},{"userId":"4","role":"Marketing Lead","tenantId":"324","username":"Claire"},{"userId":"5","role":"Senior Engineer","tenantId":"325","username":"Joanna"},{"userId":"6","role":"Manager","tenantId":"326","username":"Shawn"}]' navigation="Basic" loadingicon=""
                showheader="true" filteronkeypress="false" showrecordcount="true" navigationalign="right"
                spacing="normal" radioselect="false" multiselect="false" enablesort="true"
                showrowindex="false" enablecolumnselection="true" gridfirstrowselect="true" iconclass=""
                filtermode="search" formposition="top">
                <wm-table-column binding="userId" caption="User Id" width="100px" primary-key="true"
                    edit-widget-type="number" show="true" type="integer" generator="identity"
                    readonly="true" showineditmode="true"></wm-table-column>
                    <wm-table-column binding="role" caption="Role" pcdisplay="true" mobiledisplay="true"
                    tabletdisplay="true"></wm-table-column>
                <wm-table-column binding="tenantId" caption="Tenant Id" pcdisplay="true" mobiledisplay="true"
                    tabletdisplay="true"></wm-table-column>
                <wm-table-column binding="username" caption="Username" pcdisplay="true" mobiledisplay="true"
                    tabletdisplay="true"></wm-table-column>
                <wm-table-action key="addNewRow" display-name="New" show="true" class="btn-primary"
                    iconclass="wi wi-plus" title="New" action="addNewRow()" shortcutkey="" disabled="false"
                    position="header" widget-type="button"></wm-table-action>`],
    }
  }
}

export const containerSubGroup = {
  'container': {
    "name": "container",
    "namekey": "LABEL_WIDGETS_CONTAINER",
    "parent": "widgets",
    "feature": "components.layouts.container",
    "widgets": [
      {
        "widgetType": "wm-layoutgrid",
        "name": "Grid Layout",
        "namekey": "LABEL_WIDGET_LAYOUTGRID",
        "iconclass": "layoutgrid",
        "feature": "components.layouts.structure.layoutGrid",
        "apiDocLink": "classes/Layoutgrid.html",
        "widgetDocLink": "container/grid-layout",
        "dropEffectCls": "wm-layoutgrid block"
      },
      {
        "widgetType": "wm-linearlayout",
        "name": "Layout",
        "namekey": "LABEL_WIDGET_LINEARLAYOUT",
        "iconclass": "linear-layout",
        "feature": "components.layouts.structure.linearLayout",
        "apiDocLink": "classes/LinearLayout.html",
        "widgetDocLink": "container/linear-layout",
        "dropEffectCls": "wm-linearlayout block"
      },
      {
        "widgetType": "wm-linear-flex-layout",
        "name": "Flex Layout",
        "namekey": "LABEL_WIDGET_LINEAR_FLEX_LAYOUT",
        "iconclass": "linear-flex-layout",
        "feature": "components.layouts.structure.linearFlexLayout",
        "apiDocLink": "classes/LinearLayout.html",
        "widgetDocLink": "container/linear-layout",
        "dropEffectCls": "wm-linearlayout block"
      },
      {
        "widgetType": "wm-accordion",
        "name": "accordion",
        "namekey": "LABEL_WIDGET_ACCORDION",
        "iconclass": "accordion",
        "feature": "components.layouts.container.accordion",
        "apiDocLink": "classes/Accordion.html",
        "widgetDocLink": "container/accordion",
        "dropEffectCls": "wm-accordion block"
      },
      {
        "widgetType": "wm-tabs",
        "name": "tabs",
        "namekey": "LABEL_WIDGET_TABS",
        "iconclass": "tabs",
        "feature": "components.layouts.container.tabs",
        "apiDocLink": "classes/Tabs.html",
        "widgetDocLink": "container/tabs",
        "dropEffectCls": "wm-tabs block"
      },
      {
        "widgetType": "wm-wizard",
        "name": "wizard",
        "namekey": "LABEL_WIDGET_WIZARD",
        "iconclass": "wizard",
        "feature": "components.layouts.container.wizard",
        "apiDocLink": "classes/Wizard.html",
        "widgetDocLink": "container/wizard",
        "dropEffectCls": "wm-wizard block",
        "keywords": "step, stepper"
      },
      {
        "widgetType": "wm-list",
        "name": "List",
        "namekey": "LABEL_WIDGET_LIST",
        "iconclass": "list",
        "feature": "components.layouts.container.list",
        "apiDocLink": "classes/List.html",
        "widgetDocLink": "list",
        "dropEffectCls": "wm-list block"
      },
      {
        "widgetType": "wm-panel",
        "name": "Panel",
        "namekey": "LABEL_WIDGET_PANEL",
        "iconclass": "panel",
        "feature": "components.layouts.container.panel",
        "apiDocLink": "classes/Panel.html",
        "widgetDocLink": "container/panel",
        "dropEffectCls": "wm-panel block"
      },
      {
        "widgetType": "wm-container",
        "name": "Container",
        "namekey": "LABEL_WIDGET_CONTAINER",
        "iconclass": "container",
        "feature": "components.layouts.container.container",
        "apiDocLink": "classes/Container.html",
        "widgetDocLink": "container/",
        "dropEffectCls": "wm-container block"
      },
      {
        "widgetType": "wm-tile",
        "name": "Tile",
        "namekey": "LABEL_WIDGET_TILE",
        "iconclass": "tile",
        "feature": "components.layouts.container.tile",
        "apiDocLink": "classes/Tile.html",
        "widgetDocLink": "container/tile",
        "dropEffectCls": "wm-tile inline"
      },
      {
        "widgetType": "wm-segmented-control",
        "name": "Segmented Control",
        "namekey": "LABEL_WIDGET_SEGMENTED_CONTROL",
        "iconclass": "segmentedcontrol",
        "feature": "components.layouts.container.segmentedcontrol",
        "apiDocLink": "classes/SegmentedControl.html",
        "widgetDocLink": "mobile-widgets/segmented-control",
        "dropEffectCls": "wm-segmented-control block"
      },
      {
        "widgetType": "wm-media-list",
        "name": "MediaList",
        "namekey": "LABEL_WIDGET_MEDIA_LIST",
        "iconclass": "media-list",
        "feature": "components.layouts.container.medialist",
        "apiDocLink": "classes/MediaList.html",
        "widgetDocLink": "mobile-widgets/media-list",
        "dropEffectCls": "wm-media-list block"
      }
    ]
  },
  'navigation': {
    "name": "navigation",
    "namekey": "LABEL_WIDGETS_NAVIGATION",
    "parent": "widgets",
    "feature": "components.layouts.navigation",
    "widgets": [
      {
        "widgetType": "wm-nav",
        "name": "Nav",
        "namekey": "LABEL_WIDGET_NAV",
        "iconclass": "nav",
        "feature": "components.layouts.navigation.nav",
        "apiDocLink": "classes/Nav.html",
        "widgetDocLink": "navigation/nav",
        "dropEffectCls": "wm-nav block"
      },
      {
        "widgetType": "wm-navbar",
        "name": "Navbar",
        "namekey": "LABEL_WIDGET_NAVBAR",
        "iconclass": "navbar",
        "feature": "components.layouts.navigation.navbar",
        "apiDocLink": "classes/Navbar.html",
        "widgetDocLink": "navigation/nav-bar",
        "dropEffectCls": "wm-navbar block"
      },
      {
        "widgetType": "wm-breadcrumb",
        "name": "Breadcrumb",
        "namekey": "LABEL_WIDGET_BREADCRUMB",
        "iconclass": "breadcrumb",
        "feature": "components.layouts.navigation.breadcrumb",
        "apiDocLink": "classes/Breadcrumb.html",
        "widgetDocLink": "navigation/breadcrumb",
        "dropEffectCls": "wm-breadcrumb block"
      },
      {
        "widgetType": "wm-mobile-navbar",
        "name": "Navbar",
        "namekey": "LABEL_WIDGET_MOBILE_NAVBAR",
        "iconclass": "navbar",
        "feature": "components.layouts.navigation.mobilenavbar",
        "apiDocLink": "classes/MobileNavbar.html",
        "dropEffectCls": "wm-mobile-navbar block"
      },
      {
        "widgetType": "wm-mobile-tabbar",
        "name": "Tab Bar",
        "namekey": "LABEL_WIDGET_TABBAR",
        "iconclass": "tabbar",
        "feature": "components.layouts.navigation.mobiletabbar",
        "apiDocLink": "classes/MobileTabbar.html",
        "dropEffectCls": "wm-mobile-tabbar block"
      },
      {
        "widgetType": "wm-menu",
        "name": "Menu",
        "namekey": "LABEL_WIDGET_MENU",
        "iconclass": "menu",
        "feature": "components.widgets.formWidgets.menu",
        "apiDocLink": "classes/Menu.html",
        "widgetDocLink": "navigation/dropdown-menu",
        "dropEffectCls": "wm-menu inline"
      },
      {
        "widgetType": "wm-popover",
        "name": "Popover",
        "namekey": "LABEL_WIDGET_POPOVER",
        "iconclass": "popover",
        "feature": "components.widgets.basicWidgets.popover",
        "apiDocLink": "classes/Popover.html",
        "widgetDocLink": "navigation/popover",
        "dropEffectCls": "wm-popover inline"
      },
      {
        "widgetType": "wm-pagination",
        "name": "Pagination",
        "namekey": "LABEL_WIDGET_PAGINATION",
        "iconclass": "datanavigator",
        "feature": "components.widgets.basicWidgets.pagination",
        "dropEffectCls": "wm-pagination inline"
      }
    ]
  }

}

export const styleWorkspaceGroupConfig : {[key: string]: WidgetDetailedInfo} = {

  'wm-form-controls': {
    "widgetType" : "wm-form-controls", 
    "template": "",  
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "form-controls",
    styleWorkspaceTemplates : {
      customTemplate : [
        `<wm-layoutgrid name="layoutgrid1">
                <wm-gridrow name="gridrow2">
                    <wm-gridcolumn columnwidth="12" name="gridcolumn3">
                        <wm-form errormessage="" captionposition="left" title="Form"
                            enctype="application/x-www-form-urlencoded" method="post"
                            dataset="bind:Variables.stvformUsecases.dataSet" captionalign="left"
                            name="stvformUsecasesForm1">
                            <wm-layoutgrid columns="3" name="layoutgrid5">
                                <wm-gridrow name="gridrow9">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn11">
                                        <wm-form-field name="text Required" required="true" displayname="Text Required"
                                            show="true" placeholder="Enter text" type="string" key="text Required"
                                            widget="text" inputtype="text" readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn12">
                                        <wm-form-field name="text" displayname="Text" show="true"
                                            placeholder="Enter text" type="string" key="text" widget="text"
                                            inputtype="text" readonly="false" validationmessage="please check">
                                        </wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow47">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn13">
                                        <wm-form-field name="number Required" required="true"
                                            displayname="Number Required" show="true" placeholder="Enter Number"
                                            type="string" key="number Required" widget="number" inputtype="number"
                                            readonly="false" textalign="right" validationmessage="asrequired">
                                        </wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn14">
                                        <wm-form-field name="number" displayname="Number" show="true"
                                            placeholder="Enter Number" type="string" key="number" widget="number"
                                            inputtype="number" readonly="false" textalign="right"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow10">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn16">
                                        <wm-form-field name="textarea" displayname="Textarea" show="true"
                                            placeholder="Place your text" type="string" key="textarea" widget="textarea"
                                            readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn15">
                                        <wm-form-field name="currency" displayname="Currency" show="true"
                                            placeholder="Enter value" type="string" key="currency" widget="currency"
                                            readonly="false" textalign="right"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow111">
                                        <wm-gridcolumn columnwidth="6" name="gridcolumn21">
                                        <wm-form-field name="Select" displayname="Select" show="true" placeholder=""
                                            type="string" key="Select" widget="select" readonly="false"
                                            dataset="yes, no, maybe"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn22">
                                        <wm-form-field name="Autocomplete" displayname="Autocomplete"
                                            matchmode="startignorecase" show="true" placeholder="Search" type="string"
                                            key="Autocomplete" widget="autocomplete" readonly="false"
                                            dataset="yes, no, maybe"></wm-form-field>
                                    </wm-gridcolumn>
                                        
                                </wm-gridrow>
                                <wm-gridrow name="gridrow13">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn23">
                                        <wm-form-field name="time" displayname="Time" show="true"
                                            placeholder="Select time" type="string" key="time" widget="time"
                                            readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn25">
                                        <wm-form-field name="timestamp" displayname="Timestamp" show="true"
                                            placeholder="Select date time" type="string" key="timestamp"
                                            widget="timestamp" readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow14">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn24">
                                        <wm-form-field name="date" displayname="Date" show="true"
                                            placeholder="Select date" type="string" key="date" widget="date"
                                            datepattern="MMM d, y" outputformat="yyyy-MM-dd" readonly="false">
                                        </wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn26">
                                        <wm-form-field name="datetime" displayname="Datetime" show="true"
                                            placeholder="Select date time" type="string" key="datetime"
                                            widget="datetime" datepattern="MMM d, y h:mm:ss a" outputformat="timestamp"
                                            readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow16">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn34">
                                        <wm-form-field name="password" displayname="Password" show="true"
                                            placeholder="Enter text" type="string" key="password" widget="password"
                                            inputtype="password" readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn33">
                                        <wm-form-field name="colorpicker" displayname="Colorpicker" show="true"
                                            placeholder="Select Color" required="false" type="string" key="colorpicker"
                                            widget="colorpicker" readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                            </wm-layoutgrid>
                            <wm-form-action key="reset" name="reset" display-name="Reset" show="true"
                                class="form-reset btn-default" iconclass="wi wi-refresh" title="Reset" disabled="false"
                                widget-type="button" type="reset" update-mode="true"></wm-form-action>
                            <wm-form-action key="save" name="save" display-name="Save" show="true"
                                class="form-save btn-success" iconclass="wi wi-save" title="Save" disabled="false"
                                widget-type="button" type="submit" update-mode="true"></wm-form-action>
                        </wm-form>
                    </wm-gridcolumn>
                </wm-gridrow>
            </wm-layoutgrid>`
      ], 
      "attributeObject" : {
        tagElements : "wm-form-field"
      }
    }
  }
}

